<template>
  <div class="blog-share-bar d-flex align-items-center">
    <span class="label">Share</span>
    <SocialShare
      v-for="network in networks"
      :key="network"
      :network="network"
      :styled="false"
      :url="shareUrl"
      class="icon"
      :class="network"
    />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const networks = ['email', 'facebook', 'pinterest', 'twitter']

const route = useRoute()
const shareUrl = computed(() => `https://hpvillage.com${route.fullPath}`)
</script>

<style scoped lang="scss">
.blog-share-bar {
  font-family: $font_poppin_bold;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 1px;
  gap: 10px;

  .label {
    margin-right: 10px;
    margin-top: 2.5px;
  }

  .icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;

    &.facebook {
      background-image: url('/icons/facebook.svg');
    }

    &.twitter {
      background-image: url('/icons/twitter.svg');
    }

    &.pinterest {
      background-image: url('/icons/pinterest.svg');
    }

    &.email {
      background-image: url('/icons/email.svg');
    }
  }
}
</style>

